import { MapContainer, LayersControl } from 'react-leaflet';
import L, { Point, LatLng, Transformation } from 'leaflet';
import styled from 'styled-components/macro';
import { MapMods } from '../components/map/mapMods';
import { SDTDTileLayer } from '../components/map/tileLayer';
import { CoordinatesLayer } from '../components/map/coordinates';
import { GameTimeLayer } from '../components/map/gameTime';
import { AnimalLayer } from '../components/map/animals';
import { HostileLayer } from '../components/map/hostiles';

const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export function Map() {
  const mapInfo = {
    regionSize: 512,
    chunkSize: 16,
    tileSize: 128,
    maxZoom: 4,
  };

  const SDTD_Projection = {
    project: (latlng) => {
      return new Point(latlng.lat / Math.pow(2, mapInfo.maxZoom), latlng.lng / Math.pow(2, mapInfo.maxZoom));
    },

    unproject: (point) => {
      return new LatLng(point.x * Math.pow(2, mapInfo.maxZoom), point.y * Math.pow(2, mapInfo.maxZoom));
    },
  };

  const SDTD_CRS = L.extend({}, L.CRS.Simple, {
    projection: SDTD_Projection,
    transformation: new Transformation(1, 0, -1, 0),

    scale: function (zoom) {
      return Math.pow(2, zoom);
    },
  });

  return (
    <Container>
      <MapContainer
        style={{ width: '100%', height: '100%' }}
        center={[0, 0]}
        zoom={Math.max(0, mapInfo.maxZoom - 3)}
        scrollWheelZoom={false}
        attributionControl={false}
        crs={SDTD_CRS}
      >
        <SDTDTileLayer mapInfo={mapInfo}></SDTDTileLayer>
        <CoordinatesLayer />
        <GameTimeLayer />

        <LayersControl position="topright">
          <LayersControl.Overlay name="Animals">
            <AnimalLayer />
          </LayersControl.Overlay>

          <LayersControl.Overlay name="Hostiles">
            <HostileLayer />
          </LayersControl.Overlay>
        </LayersControl>
        <MapMods />
      </MapContainer>
    </Container>
  );
}
